import React, { useContext } from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, AuthContext } from './context/AuthContext';
import Navbar from './components/layout/Navbar';
import PortfolioItemView from './components/learner/PortfolioItemView';
import LearnerPortfolio from './pages/LearnerPortfolio'; // Add this import

// Pages
import Home from './pages/Home';
import AuthPage from './pages/AuthPage';
import AdminSetup from './pages/admin/AdminSetup';
import AdminDashboard from './pages/admin/AdminDashboard';
import MentorDashboard from './pages/MentorDashboard';
import LearnerDashboard from './pages/LearnerDashboard';
import AssignmentView from './pages/AssignmentView';

// Protected Route component
const ProtectedRoute = ({ element, allowedRoles }) => {
  const { currentUser, userRole, loading } = useContext(AuthContext);
  
  if (loading) return <div>Loading...</div>;
  
  // If not authenticated, redirect to login
  if (!currentUser) {
    console.log("Not authenticated, redirecting to login"); // Debug log
    return <Navigate to="/login" />;
  }
  
  console.log("Protected route - user role:", userRole, "allowed roles:", allowedRoles); // Debug log
  
  // Check if user's role is in the allowedRoles array
  if (!allowedRoles.includes(userRole)) {
    console.log("Role not allowed, redirecting"); // Debug log
    
    // Redirect to appropriate dashboard based on role
    if (userRole === 'admin') {
      return <Navigate to="/admin" />;
    } else if (userRole === 'mentor') {
      return <Navigate to="/mentor" />;
    } else if (userRole === 'learner') {
      return <Navigate to="/learner" />;
    } else {
      return <Navigate to="/login" />;
    }
  }
  
  // If user has proper role, render the component
  return element;
};

function App() {
  return (
    <AuthProvider>
      <Navbar />
      <div className="container">
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/login" element={<AuthPage />} />
          
          {/* Redirect any register attempts to login */}
          <Route path="/register" element={<Navigate to="/login" replace />} />
          <Route path="/admin-setup" element={<AdminSetup />} />
          
          {/* Portfolio routes */}
          <Route 
            path="/portfolio/:assignmentId" 
            element={
              <ProtectedRoute 
                element={<PortfolioItemView />} 
                allowedRoles={['learner', 'mentor', 'admin']} 
              />
            } 
          />
          
          <Route 
            path="/portfolio" 
            element={
              <ProtectedRoute 
                element={<LearnerPortfolio />} 
                allowedRoles={['learner', 'mentor', 'admin']} 
              />
            } 
          />
          
          <Route 
            path="/admin/*" 
            element={
              <ProtectedRoute 
                element={<AdminDashboard />} 
                allowedRoles={['admin']} 
              />
            } 
          />
          
          <Route 
            path="/mentor/*" 
            element={
              <ProtectedRoute 
                element={<MentorDashboard />} 
                allowedRoles={['mentor', 'admin']} 
              />
            } 
          />
          
          <Route 
            path="/learner/*" 
            element={
              <ProtectedRoute 
                element={<LearnerDashboard />} 
                allowedRoles={['learner', 'mentor', 'admin']} 
              />
            } 
          />
          
          <Route 
            path="/assignments/:assignmentId" 
            element={
              <ProtectedRoute 
                element={<AssignmentView />} 
                allowedRoles={['learner', 'mentor', 'admin']} 
              />
            } 
          />
          
          {/* Default redirect to login */}
          <Route path="*" element={<Navigate to="/login" replace />} />
        </Routes>
      </div>
    </AuthProvider>
  );
}

export default App;